var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiumBenefitSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916664 10.9993C0.916664 5.43335 5.434 0.916016 11 0.916016C16.566 0.916016 21.0833 5.43335 21.0833 10.9993C21.0833 16.5654 16.566 21.0827 11 21.0827C5.434 21.0827 0.916664 16.5654 0.916664 10.9993ZM3.94166 10.9993L8.98333 16.041L18.0583 6.96602L16.6366 5.53418L8.98333 13.1874L5.36341 9.5776L3.94166 10.9993Z",
    fill: "url(#paint0_linear_7233_9650)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7233_9650",
    x1: 0.916664,
    y1: 0.916016,
    x2: 45.9775,
    y2: 8.15493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2741E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumBenefitSuccess);
export default __webpack_public_path__ + "static/media/premium-benefit-success.fa5a283a8a4cfbb6df975f709acb1aa7.svg";
export { ForwardRef as ReactComponent };